<div class="row">
    <div class="col-sm-4">
        <h3>{{title}}</h3>
    </div>
    <div class="col-sm-8 text-end">
        <ul style="float: right;" class="nav nav-tabs border-tab" id="top-tab" role="tablist">
            <li class="nav-item" *ngFor="let item of Menu ">
                <a [ngStyle]="{'color': item.isActiveMenu ? '#00737e' : null}" *ngIf="item.menuNavigateType == 'internal'" class="nav-link" (click)="changeSubmenu(item)" style="padding-top: 0.85rem;">{{item.menuName}}</a>
                <a [ngStyle]="{'color': item.isActiveMenu ? '#00737e' : null}" *ngIf="item.menuNavigateType == 'external'" target="_blank" class="nav-link" [href]="item.navigateURL" style="padding-top: 0.85rem;">{{item.menuName}}</a>
                <a [ngStyle]="{'color': item.isActiveMenu ? '#00737e' : null}" *ngIf="item.menuNavigateType == 'button-external'" target="_blank" [href]="item.navigateURL" style="height: 40px; position: absolute; right: 0px; margin-right: 20px; border-color: #00A6B6; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                    {{item.menuName}}
                </a>
                <a [ngStyle]="{'background-color': item.isActiveMenu ? '#00737e' : null, 'color': item.isActiveMenu ? 'white' : '#00a6b6'}" *ngIf="item.menuNavigateType == 'button-internal'" (click)="changeSubmenu(item)" style="border-color: #00A6B6; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                    {{item.menuName}}
                </a>

            </li>
        </ul>
    </div>
</div>